import { FormEvent, useCallback, useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { notify } from '@agent-zone/ui-library/Toast';
import { apiPrefix } from '../../../api';
import { useFetch } from '../../../hooks/useFetch';
import { useForm } from '../../../hooks/useForm';

interface Hook {
  handleSubmit: (e: FormEvent) => void;
  isLoading: boolean;
  values: {
    pesel: string;
  };
  data?: any;
  onChangeFieldValue: (fieldName: 'pesel', fieldValue: unknown) => void;
}

export function usePasswordResetPESEL(): Hook {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { values, onChangeFieldValue } = useForm({ pesel: '' });

  // submit
  const [formSubmit, data, isLoading, formError] = useFetch<
  { email: string },
  string
  >();

  const handleSubmit = useCallback<Hook['handleSubmit']>(
    async (e: FormEvent) => {
      e.preventDefault();

      if (executeRecaptcha) {
        const recaptchaResponse = await executeRecaptcha();
        await formSubmit(`${apiPrefix}/onboarding-auth/public/reset`, {
          method: 'POST',
          redirect: 'error',
          body: JSON.stringify({
            pesel: values.pesel,
            recaptchaResponse,
          }),
        });
      }
    },
    [formSubmit, values, executeRecaptcha],
  );

  useEffect(() => {
    if (formError) {
      notify({
        variant: 'error',
        text: 'Podany PESEL i/lub hasło są nieprawidłowe. Popraw wprowadzone dane i spróbuj ponownie.',
      });
    }
  }, [formError]);

  return {
    values: {
      pesel: `${values.pesel}`,
    },
    data,
    isLoading,
    handleSubmit,
    onChangeFieldValue,
  };
}
